export class PersonnelStatus {
    id : number;
    statusCode : string;
    statusName : string;
}